import { render, staticRenderFns } from "./addLeaderboardBanner.vue?vue&type=template&id=95a88652&lang=pug"
import script from "./addLeaderboardBanner.vue?vue&type=script&lang=js"
export * from "./addLeaderboardBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports